import {Navbar, Project} from "@/api";
import {SET_NAVBAR_IS_FETCH, SET_NAVBAR, SET_NAVBAR_WINDOW_WIDTH} from "@/store/navbar/mutations";

export const FETCH_NAVBAR = 'fetchNavbar';
export const GET_MESSAGES = 'getMessages';
export const MARK_AS_READ_MESSAGES = 'markAsReadMessages';

export default {
    [FETCH_NAVBAR](context) {
        if (context.state.navbar.isGuest || context.state.navbar.isMainDomain) {
            context.commit(SET_NAVBAR_IS_FETCH, false);
            return;
        } else {
            context.commit(SET_NAVBAR_IS_FETCH, true);
        }

        return Navbar()
            .get({projectId: context.state.navbar.projectId})
            .then(response => {
                context.commit(SET_NAVBAR, response.data);
                context.commit(SET_NAVBAR_WINDOW_WIDTH, window.innerWidth);
            })
            .catch(error => {
                throw error;
            })
            .finally(() => context.commit(SET_NAVBAR_IS_FETCH, false));
    },
    [GET_MESSAGES](context, params) {
        return Project(context.state.navbar.projectId)
            .Messages()
            .get(params);
    },
    [MARK_AS_READ_MESSAGES](context, params) {
        return Project(context.state.navbar.projectId)
            .Messages()
            .markAsRead(params);
    }
}
